import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import validateAddress, {
    chain,
    ValidateEmail,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress"; 

type ValidateAddressProps = Parameters<typeof ValidateEmail>[0];

export const CustomValidateEmail = (props: ValidateAddressProps) => {
    const currentUserIsGuest = getCurrentUserIsGuest(props.getState());

    // Skip email validation entirely for logged-in users
    if (!currentUserIsGuest) {
        return;
    }

    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { email } = props.parameter.address;

    if (addressFieldDisplayCollection.email?.isVisible && validationRules.email?.isRequired && (!email || email.trim().length <= 0)) {
        props.addressErrors.email = siteMessage("Field_Required", addressFieldDisplayCollection.email.displayName);
    } else if (email && email.trim().length > 0 && !validateEmail(email)) {
        props.addressErrors.email = siteMessage("AddressInfo_EmailAddress_Validation");
    }
};

// Replace original ValidateEmail in the handler chain
replaceInChain(
    chain,
    ValidateEmail,
    CustomValidateEmail
);

export default validateAddress;